import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';

import { AuthProvider, useAuth } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';

import WelcomePage       from './pages/WelcomePage';
import AuthPage          from './pages/AuthPage';
import BirthDetailsPage  from './pages/BirthDetailsPage';
import ChartLoadingPage  from './pages/ChartLoadingPage';
import HomePage          from './pages/HomePage';
import ReadingPage       from './pages/ReadingPage';
import PaywallPage       from './pages/PaywallPage';
import SettingsPage      from './pages/SettingsPage';
import AdminPage         from './pages/AdminPage';
import PricingPage       from './pages/PricingPage';
import BabyNamesPage     from './pages/BabyNamesPage';
import HistoryPage       from './pages/HistoryPage';
import FamilyPage        from './pages/FamilyPage';
import FamilyReadingPage from './pages/FamilyReadingPage';
import HowJyotiWorksPage from './pages/HowJyotiWorksPage';
import MyChartPage       from './pages/MyChartPage';
import { PrivacyPage, TermsPage, DisclaimerPage, AboutJyotiPage } from './pages/LegalPages';
import BottomNav         from './components/BottomNav';
import LanguageToggle    from './components/LanguageToggle';

// Pages that show the bottom nav
const MAIN_PATHS = ['/home', '/reading', '/chart', '/settings'];

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ minHeight: '100vh', background: '#0A0F1E', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16 }}>
      <div style={{ fontSize: 36, color: '#C9A84C' }}>✦</div>
      <p style={{ color: '#8A8580', fontSize: 14 }}>Loading…</p>
    </div>
  );
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function AppRoutes() {
  const { user, profile, loading } = useAuth();
  const { pathname } = useLocation();
  const showNav = MAIN_PATHS.some(p => pathname.startsWith(p));

  if (loading) return (
    <div style={{ minHeight: '100vh', background: '#0A0F1E', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16 }}>
      <div style={{ fontSize: 36, color: '#C9A84C' }}>✦</div>
      <p style={{ color: '#8A8580', fontSize: 14 }}>Loading…</p>
    </div>
  );

  return (
    <>
      <LanguageToggle />
      <div style={{ paddingBottom: showNav ? 72 : 0 }}>
        <Routes>
          <Route path="/"              element={<WelcomePage />} />
          <Route path="/auth"          element={user ? <Navigate to={profile?.chart ? '/home' : '/birth-details'} /> : <AuthPage />} />
          <Route path="/birth-details" element={<ProtectedRoute><BirthDetailsPage /></ProtectedRoute>} />
          <Route path="/chart-loading" element={<ProtectedRoute><ChartLoadingPage /></ProtectedRoute>} />
          <Route path="/home"          element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
          <Route path="/reading"       element={<ProtectedRoute><ReadingPage /></ProtectedRoute>} />
          <Route path="/chart"         element={<ProtectedRoute><MyChartPage /></ProtectedRoute>} />
          <Route path="/paywall"       element={<ProtectedRoute><PaywallPage /></ProtectedRoute>} />
          <Route path="/settings"      element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
          <Route path="/baby-names"    element={<ProtectedRoute><BabyNamesPage /></ProtectedRoute>} />
          <Route path="/history"       element={<ProtectedRoute><HistoryPage /></ProtectedRoute>} />
          <Route path="/family"        element={<ProtectedRoute><FamilyPage /></ProtectedRoute>} />
          <Route path="/family/:memberId/reading" element={<ProtectedRoute><FamilyReadingPage /></ProtectedRoute>} />
          <Route path="/pricing"       element={<PricingPage />} />
          <Route path="/admin"         element={<AdminPage />} />
          <Route path="/how-jyoti-works" element={<HowJyotiWorksPage />} />
          <Route path="/privacy"       element={<PrivacyPage />} />
          <Route path="/terms"         element={<TermsPage />} />
          <Route path="/disclaimer"    element={<DisclaimerPage />} />
          <Route path="/about-jyoti"   element={<AboutJyotiPage />} />
          <Route path="*"              element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      {showNav && user && <BottomNav />}
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <Router>
          <div className="app-shell">
            <AppRoutes />
          </div>
        </Router>
      </LanguageProvider>
    </AuthProvider>
  );
}
